<div class="payment-status-page">
  <div class="content">
    <div class="icon">
      <ng-container *ngIf="icon() as ic">
        <img *ngIf="isImgIcon(ic)" class="icon-img" [src]="ic.src" [alt]="ic.alt" />
        <span *ngIf="isEmojiIcon(ic)">{{ ic.text }}</span>
      </ng-container>
    </div>
    <h1 class="title">{{ title() }}</h1>
    <p class="subtitle">{{ description() }}</p>
  </div>
</div>


